import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

export const challengeResults = async () => {
  let response = {};

  try {
    response = await axiosInstance.post(`/v3/challenge_result_list`);

    //* Test for caching - TODO look into way to revalidate
    // response = await axiosInstanceCached.post(`/transaction/license/${id}`, {
    //   cache: {
    //     ttl: 1000 * 60 * 15,
    //     override: overrideCache,
    //   },
    // });
    // console.log('challengeResults show response:', response);
    // console.log('challengeResults show cached:', response.cached);
    // // console.log('challengeResults show ttl:', response.config?.cache?.ttl);
    // // console.log('challengeResults show config:', response.config);
    // console.log('challengeResults show duration:', response.duration);
    // console.log('============================');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
